import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/popover/popover.tsx
import * as PopoverPrimitive from "@radix-ui/react-popover";
import React from "react";
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverClose = PopoverPrimitive.Close;
var PopoverContent = React.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref) => /* @__PURE__ */ React.createElement(PopoverPrimitive.Portal, null, /* @__PURE__ */ React.createElement(
  PopoverPrimitive.Content,
  {
    ref,
    align,
    sideOffset,
    className: cn(
      "z-50 overflow-hidden rounded-md border outline-none",
      className
    ),
    ...props
  }
)));

export {
  Popover,
  PopoverTrigger,
  PopoverClose,
  PopoverContent
};
